import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { THEMES, DEFAULT_THEME } from '../utils/oshiThemes';
import '../styles/OshiTop3.css';

const RANK_COLORS = ['#F5C842', '#B0BEC5', '#CD7F32'];
const RANK_LABELS = ['1位', '2位', '3位'];
const INTRO_DURATION_MS = 1950;

const CUT_IN_ANIMS = ['oshi3CutInLeft', 'oshi3CutInBottom', 'oshi3CutInRight'];

const OshiShareClient = ({ selected, tweetUrl }) => {
  const [introPhase, setIntroPhase] = useState('playing');
  const [bubbles, setBubbles] = useState([]);

  const activeTheme = THEMES[selected[0].group] || DEFAULT_THEME;

  const buttonGradient = (() => {
    const colors = selected.map((c) => (THEMES[c.group] || DEFAULT_THEME).accent);
    return `linear-gradient(90deg, ${colors[0]} 0%, ${colors[1]} 50%, ${colors[2]} 100%)`;
  })();

  useEffect(() => {
    const t = setTimeout(() => setIntroPhase('done'), INTRO_DURATION_MS);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    setBubbles(
      Array.from({ length: 18 }, (_, i) => ({
        id: i,
        creator: selected[i % selected.length],
        size: 36 + Math.random() * 32,
        left: 3 + Math.random() * 94,
        duration: 8 + Math.random() * 7,
        delay: -(Math.random() * 12),
        wobble: (Math.random() > 0.5 ? 1 : -1) * (24 + Math.random() * 48),
      }))
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="oshi3-page">
      {/* 3パネル背景 */}
      <div className="oshi3-bg-panels">
        {selected.map((creator, i) => {
          const theme = THEMES[creator.group] || DEFAULT_THEME;
          return (
            <div key={creator.id} className="oshi3-bg-panel">
              <img src={creator.image} alt="" aria-hidden="true" />
              <div className="oshi3-bg-panel-overlay" style={{ background: theme.panelOverlay }} />
              {i > 0 && (
                <div
                  className="oshi3-bg-panel-separator"
                  style={{
                    background: `linear-gradient(90deg, transparent, ${theme.accent}80, transparent)`,
                  }}
                />
              )}
            </div>
          );
        })}
      </div>

      {/* UIオーバーレイ */}
      <div className="oshi3-ui-overlay" style={{ background: activeTheme.uiOverlay }} />

      {/* カットインイントロ */}
      {introPhase === 'playing' && (
        <div className="oshi3-intro">
          {selected.map((creator, i) => {
            const theme = THEMES[creator.group] || DEFAULT_THEME;
            return (
              <div
                key={creator.id}
                className="oshi3-intro-panel"
                style={{
                  animation: `${CUT_IN_ANIMS[i]} 0.45s cubic-bezier(0.16, 1, 0.3, 1) ${i * 0.27}s both`,
                }}
              >
                <img src={creator.image} alt="" aria-hidden="true" />
                <div className="oshi3-intro-panel-overlay" style={{ background: theme.panelOverlay }} />
                <div className="oshi3-intro-gradient-top" />
                <div className="oshi3-intro-gradient-bottom" />
                {i > 0 && (
                  <div
                    className="oshi3-intro-separator"
                    style={{
                      background: `linear-gradient(to bottom, transparent, ${theme.accent}cc, transparent)`,
                    }}
                  />
                )}
                {/* ランクバッジ */}
                <div
                  className="oshi3-intro-rank-badge"
                  style={{
                    background: RANK_COLORS[i],
                    boxShadow: `0 0 12px ${RANK_COLORS[i]}bb`,
                    animation: `oshi3PopIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) ${i * 0.27 + 0.35}s both`,
                  }}
                >
                  {RANK_LABELS[i]}
                </div>
                {/* 下端グラデーション */}
                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 64,
                    background: 'linear-gradient(to top, rgba(0,0,0,0.72), transparent)',
                  }}
                />
                {/* クリエイター名 */}
                <div
                  className="oshi3-intro-name-wrap"
                  style={{
                    animation: `oshi3FadeIn 0.35s ease-out ${i * 0.27 + 0.45}s both`,
                  }}
                >
                  <span className="oshi3-intro-name">{creator.name}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* 浮遊バブル */}
      <div className="oshi3-bubbles">
        {bubbles.map((b) => {
          const bubbleTheme = THEMES[b.creator.group] || DEFAULT_THEME;
          return (
            <div
              key={b.id}
              className="oshi3-bubble"
              style={{
                width: b.size,
                height: b.size,
                left: `${b.left}%`,
                outline: `2px solid ${bubbleTheme.accent}bb`,
                boxShadow: `0 0 10px ${bubbleTheme.accent}88, inset 0 0 6px ${bubbleTheme.accent}44`,
                '--wx': `${b.wobble}px`,
                animation: `oshi3Float ${b.duration}s ease-in-out ${b.delay}s infinite`,
              }}
            >
              <img src={b.creator.image} alt="" aria-hidden="true" />
            </div>
          );
        })}
      </div>

      {/* メインコンテンツ（イントロ後に表示） */}
      {introPhase === 'done' && (
        <main className="oshi3-share-content">
          <header className="oshi3-share-header">
            <h1 className="oshi3-share-title" style={{ color: activeTheme.titleColor }}>
              私の推しメン3
            </h1>
            <p className="oshi3-share-subtitle" style={{ color: activeTheme.subtitleColor }}>
              STPRクリエイター
            </p>
          </header>

          {/* ランキングカード */}
          <div
            className="oshi3-ranking-card"
            style={{
              background: activeTheme.cardBg,
              border: `1.5px solid ${activeTheme.cardBorderColor}55`,
            }}
          >
            <div className="oshi3-ranking-podium">
              {selected.map((creator, i) => (
                <div
                  key={creator.id}
                  className="oshi3-ranking-item"
                  style={{
                    animation: 'oshi3SlideUp 0.55s cubic-bezier(0.22, 1, 0.36, 1) both',
                    animationDelay: `${i * 130}ms`,
                  }}
                >
                  <span
                    className="oshi3-ranking-rank-num"
                    style={{
                      color: RANK_COLORS[i],
                      animation: 'oshi3PopIn 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) both',
                      animationDelay: `${i * 130 + 350}ms`,
                      textShadow: `0 0 14px ${RANK_COLORS[i]}99`,
                    }}
                  >
                    {RANK_LABELS[i]}
                  </span>
                  <div
                    className={`oshi3-ranking-avatar ${i === 0 ? 'rank-1' : i === 1 ? 'rank-2' : 'rank-3'}`}
                    style={{
                      border: `4px solid ${RANK_COLORS[i]}`,
                      boxShadow: `0 0 20px ${RANK_COLORS[i]}77, 0 0 0 2px ${activeTheme.accent}44`,
                      animation: 'oshi3PopIn 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) both',
                      animationDelay: `${i * 130 + 200}ms`,
                    }}
                  >
                    <img src={creator.image} alt={creator.name} />
                  </div>
                  <span
                    className="oshi3-ranking-name"
                    style={{ color: activeTheme.cardText }}
                  >
                    {creator.name}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* アクションボタン */}
          <div className="oshi3-share-actions">
            <a
              href={tweetUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="oshi3-tweet-btn"
              style={{
                background: buttonGradient,
                boxShadow: `0 4px 24px ${activeTheme.accentGlow}`,
              }}
            >
              <svg viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.631 5.905-5.631Zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
              Xにシェアする
            </a>
            <Link
              to="/oshi3"
              className="oshi3-back-link"
              style={{ color: activeTheme.subtitleColor }}
            >
              ← 選び直す
            </Link>
          </div>
        </main>
      )}
    </div>
  );
};

export default OshiShareClient;
